import { Link } from 'react-router-dom';
import { GenericCatalogTable } from "../../../components/generic-catalog-table";
import { ScrollReveal } from "../../../components/scroll-reveal";
import { PCI_DSS_CATALOG, PCI_REQUIREMENTS } from "../../../data/pci-dss-controls";

export default function PciDssFramework() {
  const columns = [
    { accessorKey: "requirement", header: "Requirement", size: 120 },
    { accessorKey: "subRequirement", header: "Sub-Requirement", size: 140 },
    { accessorKey: "description", header: "Description", size: 320 },
    { accessorKey: "testingProcedure", header: "Testing Procedure", size: 260 },
    { accessorKey: "implementationGuidance", header: "Implementation Guidance", size: 260 },
    { accessorKey: "evidence", header: "Evidence", size: 220 },
    { accessorKey: "rbiMapping", header: "RBI Mapping", size: 140 },
    { accessorKey: "compensatingControl", header: "Compensating Control", size: 220 },
  ];
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>

        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
            International Frameworks / PCI-DSS
          </div>

          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            PCI DSS v4.0
            <br />
            Payment Card Industry Standard
          </h1>

          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            Protecting cardholder data across the payment ecosystem — merchants, processors, acquirers, and service providers.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#pci-catalog"
              className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#10B981] to-[#059669] px-5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              Download Requirements Matrix
            </a>
            <a
              href="#saq"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary transition-colors hover:bg-white/10"
            >
              View SAQ Navigator
            </a>
            <Link
              to="/frameworks/india/rbi"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl px-5 text-sm font-semibold text-[color:var(--text-link)] transition-colors hover:text-text-primary"
            >
              Back to India →
            </Link>
          </div>

          <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { k: "Requirements", v: "12" },
              { k: "Sub-controls", v: "250+" },
              { k: "Effective", v: "Mar 2024" },
            ].map((s) => (
              <div key={s.k} className="glass-card sheen p-5">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                  {s.k}
                </div>
                <div className="mt-2 font-[family:var(--font-space-grotesk)] text-3xl font-semibold text-text-primary">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-secondary py-20" id="saq">
        <div className="container-ivalue">
          <ScrollReveal>
            <div className="glass-card p-6">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">PCI requirements</div>
              <h2 className="mt-2 text-2xl font-extrabold tracking-[-0.02em] text-text-primary md:text-3xl">12 requirements</h2>
              <div className="mt-6 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                {PCI_REQUIREMENTS.map((r) => (
                  <div key={r} className="rounded-xl border border-border-subtle bg-white/5 px-3 py-2 text-sm text-text-secondary">
                    {r}
                  </div>
                ))}
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <section className="bg-background-primary py-20" id="pci-catalog">
        <div className="container-ivalue">
          <ScrollReveal>
            <div>
              <h2 className="text-3xl font-extrabold tracking-[-0.02em] text-text-primary md:text-5xl">PCI-DSS requirements matrix</h2>
              <p className="mt-3 max-w-3xl text-lg text-text-secondary">
                Seeded with representative controls (expandable to the full 250+ sub-controls).
              </p>
            </div>
          </ScrollReveal>

          <div className="mt-10">
            <GenericCatalogTable
              data={PCI_DSS_CATALOG}
              columns={columns}
              csvColumns={[
                { header: "Requirement", accessorKey: "requirement" },
                { header: "Sub-Requirement", accessorKey: "subRequirement" },
                { header: "Description", accessorKey: "description" },
                { header: "Testing", accessorKey: "testingProcedure" },
                { header: "Guidance", accessorKey: "implementationGuidance" },
                { header: "Evidence", accessorKey: "evidence" },
                { header: "RBI", accessorKey: "rbiMapping" },
                { header: "Compensating", accessorKey: "compensatingControl" },
              ]}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
